import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {i18n} from '@toolify/client/src/setup/i18n'

const {t} = i18n.global

interface INewMessageNotificationTitleStrategy {
  getActionText: (unreadGroupCount: number) => string
  includeResourceTitleItems: boolean
}

export const defaultNewMessageNotificationTitleStrategy: INewMessageNotificationTitleStrategy = {
  getActionText: (unreadGroupCount: number) => unreadGroupCount > 1
    ? t('notifications.notificationItemTitleItems.wroteNewMessages', {count: unreadGroupCount})
    : t('notifications.notificationItemTitleItems.wroteANewMessage'),
  includeResourceTitleItems: true,
}

const directNewMessageNotificationTitleStrategy: INewMessageNotificationTitleStrategy = {
  getActionText: (unreadGroupCount: number) => unreadGroupCount > 1
    ? t('notifications.notificationItemTitleItems.messagedYouMultiple', {count: unreadGroupCount})
    : t('notifications.notificationItemTitleItems.messagedYou'),
  includeResourceTitleItems: false,
}

export const NewMessageNotificationTitleStrategyByConversationTypeMap = new Map<ConversationType, INewMessageNotificationTitleStrategy>([
  [ConversationType.Workspace, defaultNewMessageNotificationTitleStrategy],
  [ConversationType.CloudFile, defaultNewMessageNotificationTitleStrategy],
  [ConversationType.DatabaseCell, defaultNewMessageNotificationTitleStrategy],
  [ConversationType.DatabaseFile, defaultNewMessageNotificationTitleStrategy],
  [ConversationType.CallRoom, defaultNewMessageNotificationTitleStrategy],
  [ConversationType.Direct, directNewMessageNotificationTitleStrategy],
])
